export default __webpack_public_path__ + "static/media/reading-character.ce39efeb.png";